import { render, staticRenderFns } from "./DialogMostrarCombustivel.vue?vue&type=template&id=4513bb6d&"
import script from "./DialogMostrarCombustivel.vue?vue&type=script&lang=js&"
export * from "./DialogMostrarCombustivel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports